import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { normalizePath } from "./lib/site";

const root = document.getElementById("root")!;
if (root.hasChildNodes() && root.dataset.prerenderPath === normalizePath(window.location.pathname)) {
  hydrateRoot(root, <App />);
} else {
  createRoot(root).render(<App />);
}
